import { GroupType } from "src/Pages/Company/Dashboard/services/api/api.models";

const API_VERSIONS = {
  V1: "v1",
  V2: "v2",
};

export const DASHBOARD_ROUTES = {
  GET: {
    DASHBOARD_MODULE_CONFIGURATION: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/modules`,
    DASHBOARD_MODULE_COMPANY_REDIRECTS_WIDGET: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/widget/company-redirects`,
    DASHBOARD_MODULE_GROUPS: (companyId: string, groupType: GroupType) =>
      `${API_VERSIONS.V1}/companies/${companyId}/groups/${groupType}`,
    DASHBOARD_MODULE_DEFAULT_LOGO: `${API_VERSIONS.V1}/logos/default`,
    DASHBOARD_MENU_TEMPLATES: `${API_VERSIONS.V1}/menus/templates`,
    DASHBOARD_MENU_TEMPLATES_PAGED: `${API_VERSIONS.V1}/menus/templates/paged`,
    DASHBOARD_MENU_TEMPLATE: (menuId: string) =>
      `${API_VERSIONS.V1}/menus/templates/${menuId}`,
    DASHBOARD_MENU_VARIANTS: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/menus/variants`,
    DASHBOARD_MENU_VARIANT: (companyId: string, menuId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/menus/variants/${menuId}`,
    DASHBOARD_COMPANY_CONFIGURATION: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/configuration`,
    DASHBOARD_MODULES_CONFIGURATION: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/modules-configuration`,
  },
  POST: {
    DASHBOARD_MODULE_COMPANY_REDIRECTS_NEW_ICON: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/widget/company-redirects/icon`,
    DASHBOARD_MODULE_COMPANY_REDIRECTS_NEW_ICON_FROM_WEBSITE: (
      companyId: string
    ) =>
      `${API_VERSIONS.V1}/companies/${companyId}/widget/company-redirects/icon/website`,
    DASHBOARD_MODULE_CREATE_LOGO: `${API_VERSIONS.V1}/logos`,
    DASHBOARD_MENU_TEMPLATE: `${API_VERSIONS.V1}/menus/templates`,
    DASHBOARD_MENU_VARIANT: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/menus/variants`,
  },
  PUT: {
    DASHBOARD_MODULE_CONFIGURATION: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/modules`,
    DASHBOARD_MODULE_COMPANY_REDIRECTS: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/widget/company-redirects`,
    DASHBOARD_MODULE_DEFAULT_LOGO: `${API_VERSIONS.V1}/logos/default`,
    DASHBOARD_MENU_TEMPLATE: (templateId: string) =>
      `${API_VERSIONS.V1}/menus/templates/${templateId}`,
    DASHBOARD_MENU_VARIANT: (companyId: string, menuId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/menus/variants/${menuId}`,
    DASHBOARD_COMPANY_CONFIGURATION: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/configuration`,
    DASHBOARD_MODULES_CONFIGURATION: (companyId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/modules-configuration`,
  },
  DELETE: {
    DASHBOARD_MENU_TEMPLATE: (templateId: string) =>
      `${API_VERSIONS.V1}/menus/templates/${templateId}`,
    DASHBOARD_MENU_VARIANT: (companyId: string, menuId: string) =>
      `${API_VERSIONS.V1}/companies/${companyId}/menus/variants/${menuId}`,
  },
};
